<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <a-spin :spinning="spinning">
            <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'>
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-7">
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="As of"><br>
                                            <a-date-picker v-model="inputDate" format="MM-DD-YYYY" placeholder="Start Date" style="width:100%"/>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Company">
                                            <a-select v-model="inputCompany" showSearch allowClear placeholder="Select Company" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="getCompanySites()" :allowClear='true'>
                                                <a-select-option v-for="option in userCompanyOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Site Type">
                                            <a-select v-model="inputSiteType" showSearch placeholder="Select Site Type" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="getCompanySites()" :allowClear='true'>
                                                <a-select-option v-for="option in siteTypeOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Site Concept">
                                            <a-select v-model="inputSiteConcept" showSearch placeholder="Select Site Type" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" @change="getCompanySites()" :allowClear='true'>
                                                <a-select-option v-for="option in siteConceptOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Site">
                                            <a-select mode="multiple" v-model="inputSite" showSearch allowClear placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                                <a-select-option v-for="option in userSiteCompanyOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input alternative="" label="Select Brand">
                                            <a-select mode="multiple" v-model="inputBrand" showSearch placeholder="All Brands" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                                <a-select-option v-for="option in brandsOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                            </a-select>
                                        </base-input>
                                    </div>
                                </div>
            
                                <div class="row">
                                    <div class="col-md-7">
                                        <base-input label="Sort By" >
                                            <select class="form-control" size="large" v-model="inputSortBy" @click.prevent="autoChange">
                                                <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </base-input>
                                    </div>
                                    <div class="col-md-2 mt-3 pt-3">
                                        <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                            {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                        </button>
                                    </div>
                                </div>
                                
                                <base-checkbox class="mb-3" v-model="isSeparateSite">
                                    Separate per site
                                </base-checkbox>
            
                                <!-- <div class="row">
                                    <div class="col-md-7">
                                        <button class="btn btn-sm" style="background-color: #394A5D; color: white;" @click.prevent="advanceFilter(true)">
                                            {{toggleLabel}}
                                        </button>
                                    </div>
                                </div> -->
                            </div>
                            <div class="col-md-4 align-self-center">
                                <div v-if="reportDescription != ''" class="card">
                                    <div class="card-body">
                                        <div class="card-text">
                                            {{ reportDescription }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <!-- <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp; -->
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                                <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+fileDate">
                                    <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="clearJsonData"> Download CSV </button> &nbsp; &nbsp;
                                </vue-json-to-csv>
                                <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+fileDate" type="xlsx" class="float-right"  style=" width: 20%;">
                                    <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                                </download-excel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="toggleAdvanceFilter" id="hide" class="col-md-12">
                <a-drawer title="" width="500" placement="right" @close="closeFilter" :visible="advancedFilterVisible">
                    <advance-filter :parentParams="advancedFilterParams" @changeParams="changeParams" @closeFilter="closeFilter"></advance-filter>
                </a-drawer>
            </div>
            </a-spin>
        </div>
    </a-spin>
    </template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import reportUtils, {dissectReportFilters} from '../../components/reportUtils';
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import VueJsonToCsv from 'vue-json-to-csv';
        import AdvanceFilter from '../Bir Reports/ReportAdvanceFilter'
    
        import {
            mapState,
            mapActions
        } from 'vuex'
    import { getReportDescription } from '../../utilities';
        var component_x;
    
        export default {
            data() {
                return {
                    spinning: false,
                    inputDate: moment().endOf('day'),
                    inputSite: [],
                    site_type: "ho",
                    siteOptions: [],
                    userSiteCompanyOptions: [],
                    companyOptions: [],
                    userCompanyOptions: [],
                    siteTypeOptions: [],
                    siteConceptOptions: [],
                    brandsOptions: [],
                    inputCompany: '',
                    inputSiteType: '',
                    inputSiteConcept: '',
                    inputBrand: [],
                    inputSortBy: 'product_id',
                    inputSortExtendedBy: 'product_id',
                    sortOptions: [
                        {key: 'product_id', value: 'Product Code'},
                        {key: 'barcode', value: 'Barcode'},
                        // {key: 'name', value: 'Name or Description'},
                    ],
                    sortExtendedOptions: [
                        {key: 'product_id', value: 'Product Code'},
                        {key: 'barcode', value: 'Barcode'},
                        {key: 'name', value: 'Name or Description'},
                        {key: 'onhand_qty', value: 'On-Hand Quantity'},
                        {key: 'rr_date', value: 'Last Arrival'},
                        {key: 'in_qty', value: 'Incoming Quantity'},
                        {key: 'out_qty', value: 'Outgoing Quantity'}
                    ],
                    formatOptions: [
                        {key: '1', value: 'Simple'},
                        {key: '2', value: 'Extended'},
                        {key: '3', value: 'Extended with # of days since last sale'}
                    ],
                    isShowPrev: false,
                    isSeparateSite: false,
                    birSalesReports: [],
    
                    //currDate: moment().format("L_LT").split(":").join(";"),
                    showSortInfo: 'asc',
                    JsonData: [],
                    toggleAdvanceFilter: false,
                    toggleLabel: "Advanced Filter",
                    advancedFilterParams: {},
                    params: {},
                    advancedFilterVisible: true,
                    spinning: false,
                    accessRights:[],
                    accessCostPriceRights: [],
                    reportDescription: '',
                    fileDate: null,
                    // bryan
                    selectedLocation: null,
                    locationOptions:[],
                }
            },
            mounted: async function () {
                component_x = this;
    
                var userId = secureStorage.getItem("userId")
                var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                component_x.siteOptions = sites;
                component_x.sort(component_x.siteOptions);

                component_x.userSiteCompanyOptions = sites;
                component_x.sort(component_x.userSiteCompanyOptions);
               
              // bryan
                this.siteOptions.map(({location_name}) => {
                  if(this.locationOptions.length === 0 || !this.locationOptions.includes(location_name)){
                    this.locationOptions = [...this.locationOptions,location_name].sort()
                  }
                })
                // end

                var companies = await HTTPRequest.getRequest(component_x.endPoint + "companies/get_valid_companies", null);
                component_x.companyOptions = companies;
                component_x.sort(component_x.companyOptions);

                //Get user sites company ids then map to component_x.companyOptions
                const company_ids = [...new Set(sites.map(item => item.company_id))];
                
                companies.forEach(function (item) {
                    if(company_ids.includes(item.id)){
                        component_x.userCompanyOptions.push(item)
                    }
                });

                //Get site types siteTypeOptions
                var site_types = await HTTPRequest.getRequest(component_x.endPoint + "site_types/get_valid_site_types?is_channel=false", null);
                component_x.siteTypeOptions = site_types;
                component_x.sort(component_x.siteTypeOptions);

                //Get channel types siteConceptOptions
                var site_concepts = await HTTPRequest.getRequest(component_x.endPoint + "site_concepts/get_valid_site_concepts", null);
                component_x.siteConceptOptions = site_concepts;
                component_x.sort(component_x.siteConceptOptions);

                //Get brands brandsOptions
                var brands = await HTTPRequest.getRequest(component_x.endPoint + "brands/get_valid_brands?userBrands=true", null);
                component_x.brandsOptions = brands;
                component_x.sort(component_x.brandsOptions);

    
                //let siteId = secureStorage.getItem("defaultSiteId")
                //this.inputSite = [siteId]
    
                let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
                if(site != undefined){
                    this.site_type = site.site_type
                }
                this.accessRights = this.$attrs.access_rights || []
                this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
                this.reportDescription = await getReportDescription(this.currentProfile)
            },
            computed: {
                ...mapState(['currentProfile','endPoint']),
            },
            components:{
                AdvanceFilter,VueJsonToCsv
            },
            methods: {
                moment,
                getCompanySites(){
                    //Map all site under selected company
                    component_x.inputSite = []
                    component_x.userSiteCompanyOptions = []
                    var companyLevel = []
                    var siteTypeLevel = []
                    var channelTypeLevel = []

                if(component_x.inputCompany > 0){
                    component_x.siteOptions.forEach(function (item) {
                        if(component_x.inputCompany == item.company_id){
                            component_x.userSiteCompanyOptions.push(item)
                        }
                    });
                }

                if(component_x.inputSiteType > 0){
                    var filtered_site = []
                    component_x.userSiteCompanyOptions.forEach(function (item) {
                        if(component_x.inputSiteType == item.site_type_id){
                            filtered_site.push(item)
                        }
                    });
                    component_x.userSiteCompanyOptions = filtered_site
                }

                if(component_x.inputSiteConcept > 0){
                    var filtered_site = []
                    component_x.userSiteCompanyOptions.forEach(function (item) {
                        if(component_x.inputSiteConcept == item.site_concept_id){
                            filtered_site.push(item)
                        }
                    });
                    component_x.userSiteCompanyOptions = filtered_site
                }

                
                },
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                // Advanced Info
                showSortInfoDiv(){
                    this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
                },
                autoChange(e){
                    this.inputSortExtendedBy = this.inputSortBy
                },
                autoDisable(e){
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                advanceFilter(value){
                    this.toggleAdvanceFilter = value
                    if(this.toggleAdvanceFilter == true){
                        this.toggleLabel = "Collapse Filter"
                    }else{
                        this.toggleLabel = "Advanced Filter"
                    }
                },
                closeFilter(){
                    this.advanceFilter(false)
                },
                changeParams(params, actualParams, mode){
                    this.params = params
                    this.advancedFilterParams = actualParams
    
                    if(mode == 'filter'){
                        this.advanceFilter(false);
                    }
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                formatNumber(num) {
                   return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                diffDays(date1, date2){
                    let a = moment(date1,'YYYY-MM-DD');
                    let b = moment(date2,'YYYY-MM-DD');
                    return b.diff(a, 'days');
                },
                generateReport: async function () {
                    this.spinning= true;
                    if(this.inputDate.length == 0){
                        reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                        return
                    }
    
                    let sorting = this.inputSortBy
    
                    let as_of = this.inputDate.format('MMMM DD, YYYY')
    
                    let parameters = {
                        "site_id": this.inputSite.toString(),
                        "brand_id": this.inputBrand.toString(),
                        "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                        "order": sorting,
                        "by": this.showSortInfo,
                        "isSeparate": this.isSeparateSite,
                        "isPrev": this.isShowPrev,
                        "advanced_filter": this.params
                    }
                    let get_request = await HTTPRequest.getRequest(this.endPoint + 'intransit_report_v2?', parameters);
    
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                        return
                    }
    
                    let siteSpecific = get_request;
                    if(siteSpecific.length > 0){
                        let doc = []
                        doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });
                        // let reportLogo = document.getElementById('reportLogo');
                        // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
    
                        let headers = [];
    
                        let header_top = [];
                        header_top.push(
                            {content: 'Barcode', styles: {halign: 'center'}},
                            {content: 'Document Date', styles: {halign: 'center'}},
                            {content: 'Source Site', styles: {halign: 'center'}},
                            {content: 'STO doc #', styles: {halign: 'center'}},
                            {content: 'Destination Site', styles: {halign: 'center'}},
                            {content: 'STI doc #', styles: {halign: 'center'}},
                            {content: 'In-transit QTY', styles: {halign: 'center'}},
                            {content: 'Unit Cost', styles: {halign: 'center'}},
                            {content: 'Unit Price', styles: {halign: 'center'}},
                            {content: 'Total Cost', styles: {halign: 'center'}},
                            {content: 'Total Price', styles: {halign: 'center'}}
                        )

                        headers = [header_top]
                        
    
    
                        for(let x=0; x < siteSpecific.length; x++){
                            // console.log("siteSpecific",siteSpecific);
                            this.birSalesReports = siteSpecific[x].report_details
    
                            if(x > 0 && this.birSalesReports.length > 0){
                                doc.addPage();
                            }
    
                            let reportData = [];
                            if(this.birSalesReports.length > 0){
                                let grouper = 'start'
                                let total_intransit_qty = 0
                                let total_cost = 0
                                let total_price = 0

                                let grand_intransit_qty = 0
                                let grant_total_cost = 0
                                let grant_total_price = 0
    
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    let grouper_name = ""
                                    // if(grouper == 'start'){
                                    //     let detail_header = [grouper_name];
                                    //     reportData.push(detail_header)
                                    // } else {
                                    //     if(grouper != reportLine.source_site_name){
                                    //         let detail_header = [grouper_name]
                                    //         reportData.push(detail_header)
                                    //     }
                                    // }
                                    grouper = reportLine.source_site_name
                                    let detail = [
                                        reportLine.barcode,
                                        moment(String(reportLine.document_date)).format('MMMM D, YYYY'),
                                        reportLine.source_site_name,
                                        reportLine.sto_doc_no,
                                        reportLine.target_site_name,
                                        reportLine.sti_doc_no,
                                    ]
                                    detail.push(
                                        this.convertToCurrency(Number(reportLine.intransit_qty))
                                    )
                                    detail.push(this.convertToCurrency(Number(reportLine.cost)))
                                    detail.push(this.convertToCurrency(Number(reportLine.price)))
                                    detail.push(this.convertToCurrency(Number(reportLine.intransit_qty)*Number(reportLine.cost)))
                                    detail.push(this.convertToCurrency(Number(reportLine.intransit_qty)*Number(reportLine.price)))
                                    reportData.push(detail)
                                    total_intransit_qty += Number(reportLine.intransit_qty)
                                    grand_intransit_qty += Number(reportLine.intransit_qty)
                                    total_cost += Number(reportLine.intransit_qty)*Number(reportLine.cost)
                                    grant_total_cost += Number(reportLine.intransit_qty)*Number(reportLine.cost)
                                    total_price += Number(reportLine.intransit_qty)*Number(reportLine.price)
                                    grant_total_price += Number(reportLine.intransit_qty)*Number(reportLine.price)
                                    if(i == this.birSalesReports.length-1){
                                        let sub_detail = ['','','','','']
                                        let grand_detail = ['','','','','']
                                        sub_detail.push(
                                            'Sub Total :',
                                            this.convertToCurrency(total_intransit_qty),
                                            '','',
                                            this.convertToCurrency(total_cost),
                                            this.convertToCurrency(total_price),
    
                                        )
                                        grand_detail.push(
                                            'Grand Total :',
                                            this.convertToCurrency(grand_intransit_qty),
                                            '','',
                                            this.convertToCurrency(grant_total_cost),
                                            this.convertToCurrency(grant_total_price),
    
                                        )
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, sub_detail))
    
                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(Object.assign({}, grand_detail))
                                    } else {
                                        let current_grouper = reportLine.product_id
                                        let next_grouper = this.birSalesReports[i+1].product_id
    
                                        if(current_grouper != next_grouper){
                                            let sub_detail = ['','','','','']
                                            sub_detail.push(
                                                'Sub Total :',
                                                this.convertToCurrency(total_intransit_qty),
                                                '','',
                                                this.convertToCurrency(total_cost),
                                                this.convertToCurrency(total_price),
        
                                            )
                                            reportData.push(Object.assign({}, ["rowLine"]))
                                            reportData.push(Object.assign({}, sub_detail))

                                            total_intransit_qty = 0
                                            total_cost = 0
                                            total_price = 0
                                        }
                                        
                                    }
                                }
                            }
    
                            let group_text = ""
                            let design_x = 340
                            let design_y = 200
    
                            doc.setFontSize(14);
                            doc.setFontType("bold");
                            doc.text(15,20,"In-transit Report" + group_text)
                            doc.setFontType("normal");
                            doc.setFontSize(10);
                            doc.text(15, 25, "As of " + as_of)
    
                            if (this.isSeparateSite == true) {
                                // doc.text(design_x,20,siteSpecific[x].report_details[0].site_name,"right");
                                doc.text(15, 30, `Site/s: ${siteSpecific[x].report_details[0].site_name}`)
                            } else {
                                let site_text = ''
                                if (this.inputSite.length == 0) {
                                    site_text = 'All Sites'
                                } else {
                                    let sites = this.inputSite
                                    for (var s = 0; s < sites.length; s++) {
                                        if (s == 0) {
                                            site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                        } else {
                                            site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                        }
                                    }
                                }
                                doc.text(15, 30, `Site/s: ${site_text}`)
                                // doc.text(design_x,20,site_text,"right");
                            }
                            let filterText = dissectReportFilters(parameters, [], this.formatOptions)
                            const { basic, advance } = filterText
                            doc.text(15, 35, `Filter/s: ${basic}`)
    
                            
                            let colStyles = {}
                            colStyles = {
                                0: {cellWidth: 25},
                                1: {cellWidth: 25},
                                2: {cellWidth: 25},
                                3: {cellWidth: 20},
                                4: {cellWidth: 60},
                                5: {cellWidth: 25},
                                6: {cellWidth: 30},
                                7: {cellWidth: 30},
                                8: {cellWidth: 30},
                            }
    
                            // console.log("------------")
                            // console.log("reportData",reportData)
    
                            doc.autoTable({
                                // startY: 35,
                                startY: Object.keys(this.params).length !== 0? 45 : 40,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                tableWidth: 'wrap',
                                headStyles: {
                                    lineWidth: 0.15,
                                    cellPadding: 2
                                },
                                styles: {
                                    cellPadding: 1.0, fontSize: 10,
                                    halign: 'right'
                                },
                                margin: {bottom: 25},
                                columnStyles: colStyles,
                                didParseCell: function(data) {
                                    if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                        data.cell.styles.fillColor = [0, 0, 0]
                                        data.cell.styles.fontSize = 1
                                        data.cell.styles.cellPadding = 0
                                    } else if (data.row.section == 'body' && (data.row.raw[3] == 'Grand Total :' || data.row.raw[4] == 'Grand Total :' || data.row.raw[3] == 'Sub Total :' || data.row.raw[4] == 'Sub Total :')){
                                        data.cell.styles.fontStyle = 'bold'
                                    }
                                }
                            });
    
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
                            let pageCount = doc.internal.getNumberOfPages();
    
                            for(let i = 1; i <= pageCount; i++) {
                                doc.setPage(i);
                                reportUtils.pdfTools.addFooter(doc, printed_by, "In-transit Report" + group_text, design_x, design_y, i, pageCount)
                            }
                        }
                        
                        window.open(URL.createObjectURL(doc.output("blob")))
                        //doc.save(`General_Inventory_Report_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                    }
                    this.spinning= false;
                },
                generateFile: async function() {
                    this.spinning= true;
                    // console.log(this.inputSite);
                    if(this.inputDate.length == 0){
                        reportUtils.openNotificationWithIcon(component_x, 'error', 'Please make sure to check your current filters.');
                        return
                    }
    
                    let sorting = this.inputSortBy
    
                    this.fileDate = this.inputDate.format('DD_MM_YYYY_h;mmA');
                    
                    //If all sites per company
                    var fiter_sites = ''
                    if(this.inputSite.toString() == ''){
                        //get all company sites
                        fiter_sites = this.userSiteCompanyOptions.map(function(value) {
                            return value.id;
                          });
                        console.log(fiter_sites)
                        fiter_sites = fiter_sites.toString()
                    } else {
                        fiter_sites = this.inputSite.toString()
                    }

                    let parameters = {
                        //"site_id": this.inputSite.toString(),
                        "site_id": fiter_sites,
                        "brand_id": this.inputBrand.toString(),
                        "as_of": this.inputDate.format('YYYY-MM-DD HH:mm:ss'),
                        "order": sorting,
                        "by": this.showSortInfo,
                        "isSeparate": this.isSeparateSite,
                        "isPrev": this.isShowPrev,
                    }
                    let get_request = await HTTPRequest.getRequest(this.endPoint + 'intransit_report_v2?', parameters);
    
                    if(get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                        return
                    }
    
                    // test
                    let siteSpecific = get_request;
                    if(siteSpecific.length > 0){
                        let headers = [];
                        let header_top = [];
                        let site_specific = [];
                        //
                        header_top.push('BARCODE','DESCRIPTION','STO POSTING DATE','SOURCE SITE','STO CAS #','STO QTY','DESTINATION SITE','STI CAS #','STI QTY','STI STATUS','IN-TRANSIT QTY','UNIT SRP','TOTAL SRP')
                        headers = header_top
                        
                        // console.log("-------------------")
    
                        for (let x=0; x < siteSpecific.length; x++){
                            // console.log("siteSpecific",siteSpecific);
                            this.birSalesReports = siteSpecific[x].report_details
    
                            let reportData = [];
                            if(this.birSalesReports.length > 0){
                                let grouper = 'start'
                                let total_intransit_qty = 0
                                let total_cost = 0
                                let total_price = 0

                                let grand_intransit_qty = 0
                                let grant_total_cost = 0
                                let grant_total_price = 0
    
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    let grouper_name = ""
                                    // if(grouper == 'start'){
                                    //     let detail_header = [grouper_name];
                                    //     reportData.push(detail_header)
                                    // } else {
                                    //     if(grouper != reportLine.source_site_name){
                                    //         let detail_header = [grouper_name]
                                    //         reportData.push(detail_header)
                                    //     }
                                    // }
                                    grouper = reportLine.source_site_name
                                    //'BARCODE','DESCRIPTION','STO POSTING DATE','SOURCE SITE','STO CAS #','DESTINATION SITE','STI CAS #','STI STATUS','IN-TRANSIT QTY','UNIT SRP','TOTAL SRP'
                                    let detail = [
                                        reportLine.barcode,
                                        reportLine.product_name,
                                        moment(String(reportLine.sto_posted_at)).format('MMMM D, YYYY'),
                                        reportLine.source_site_name,
                                        reportLine.sto_cas_no,
                                        reportLine.sto_qty,
                                        reportLine.target_site_name,
                                        reportLine.sti_cas_no,
                                        reportLine.sti_qty,
                                        reportLine.sti_status,
                                        reportLine.intransit_qty,
                                        reportLine.price,
                                    ]
                                    // detail.push(
                                    //     this.convertToCurrency(Number(reportLine.intransit_qty))
                                    // )
                                    // detail.push(this.convertToCurrency(Number(reportLine.cost)))
                                    // detail.push(this.convertToCurrency(Number(reportLine.price)))
                                    // detail.push(this.convertToCurrency(Number(reportLine.intransit_qty)*Number(reportLine.cost)))
                                    detail.push(this.convertToCurrency(Number(reportLine.intransit_qty)*Number(reportLine.price)))
                                    reportData.push(detail)
                                    total_intransit_qty += Number(reportLine.intransit_qty)
                                    grand_intransit_qty += Number(reportLine.intransit_qty)
                                    total_cost += Number(reportLine.intransit_qty)*Number(reportLine.cost)
                                    grant_total_cost += Number(reportLine.intransit_qty)*Number(reportLine.cost)
                                    total_price += Number(reportLine.intransit_qty)*Number(reportLine.price)
                                    grant_total_price += Number(reportLine.intransit_qty)*Number(reportLine.price)
    
                                    if(i == this.birSalesReports.length-1){
                                        let sub_detail = ['','','','']
                                        let grand_detail = ['','','','']
                                        sub_detail.push(
                                            'Sub Total :',
                                            this.convertToCurrency(total_intransit_qty),
                                            '','',
                                            this.convertToCurrency(total_cost),
                                            this.convertToCurrency(total_price),
                                        )
                                        grand_detail.push(
                                            'Grand Total :', '', '', '', '', '',
                                            this.convertToCurrency(grand_intransit_qty),
                                            '',
                                            this.convertToCurrency(grant_total_price),
                                        )
                                        // reportData.push(["---"])
                                        // reportData.push(sub_detail)
    
                                        reportData.push(["---"])
                                        reportData.push(grand_detail)
                                    } else {
                                        let current_grouper = reportLine.product_id
                                        let next_grouper = this.birSalesReports[i+1].product_id
    
                                        if(current_grouper != next_grouper){
                                            let sub_detail = ['','','','']
                                            sub_detail.push(
                                                'Sub Total :',
                                                this.convertToCurrency(total_intransit_qty),
                                                '','',
                                                this.convertToCurrency(total_cost),
                                                this.convertToCurrency(total_price),
                                            )
                                            
                                            // reportData.push(["-----"])
                                            // reportData.push(sub_detail)
                                            
                                            total_intransit_qty = 0
                                            total_cost = 0
                                            total_price = 0
                                        }
                                    }
                                }
                            }
    
                            let group_text = ""
    
                            if(this.isSeparateSite == true){
                                reportData.push([siteSpecific[x].report_details[0].site_name]);
                            } else {
                                let site_text = ''
                                if(this.inputSite.length == 0){
                                    site_text = 'All Sites'
                                } else {
                                    let sites = this.inputSite
                                    for (var s = 0; s < sites.length; s++) {
                                        if(s == 0){
                                            site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                        } else {
                                            site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                        }
                                    }
                                }
                                reportData.unshift([site_text]);
                            }
    
                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }
    
                            reportData.push(["In-transit Report" + group_text, "Printed By: " + printed_by,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA")])
    
                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;
    
                            let newJsonData=[];
    
                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                          [val]: values[i][index]
                                      }
                                  )
                                )
                              );
                              newJsonData.push(result)
                            }
    
                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                              for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                  obj[i] = '';
                                }
                              }
                            });
                            site_specific.push(newJsonData)
    
                            // this.JsonData = site_specific;
                                            }
                        // for each site specific[] convert nested to single array
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'error', 'No Data.');
                    }
                    this.spinning= false;
                },
                clearJsonData(){
                  // console.log("working",this.JsonData)
                  this.JsonData = [];
                },
                addMaskValidation(value, rights){
                    if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                        return '***';
                    }else{
                        return value
                    }
                },
                // bryan
                selectLocationFunction(){
                  if(this.inputSite.length !== 0){
                    this.inputSite = []
                  }
                  this.siteOptions.map(({location_name, id}) => {
                    if(location_name === this.selectedLocation){
                      this.inputSite = [...this.inputSite, id]
                    }
                  })
                }
            }
        };
    </script>
    
    <style></style>
    
